import { BASE_URL } from "../config";
import { getAccessToken, setAccessToken } from "./authStore";

let isRefreshing = false;
let refreshPromise = null;

async function doRefresh() {
  // Avoid multiple refresh calls in parallel
  if (isRefreshing && refreshPromise) return refreshPromise;

  isRefreshing = true;
  refreshPromise = fetch(`${BASE_URL}/api/user/login/refresh`, {
    method: "POST",
    credentials: "include", // IMPORTANT: sends cookies
    headers: { "Content-Type": "application/json" },
  })
    .then(async (res) => {
      const body = await res.json().catch(() => ({}));
      if (!res.ok) throw new Error(body.detail || "Refresh failed");
      console.log("Refresh success:", body);
      setAccessToken(body.access);
      return body.access;
    })
    .finally(() => {
      isRefreshing = false;
      refreshPromise = null;
    });

  return refreshPromise;
}

export async function apiFetch(path, options = {}, { retryOn401 = true, auth = false } = {}) {
  const token = getAccessToken();

  const headers = {
    ...(options.headers || {}),
    "Content-Type": "application/json",
  };

  if (auth && token) {
    headers.Authorization = `Bearer ${token}`;
  } else {
    delete headers.Authorization;
  }

  const res = await fetch(`${BASE_URL}api/${path}`, {
    ...options,
    headers,
    credentials: "include", // so cookies (refresh/csrf) are sent
  });

  if (res.status !== 401 || !retryOn401 || !auth) return res;

  try {
    await doRefresh();
  } catch (e) {
    return res;
  }

  const retryHeaders = {
    ...(options.headers || {}),
    Authorization: `Bearer ${getAccessToken()}`,
  };
  if (!retryHeaders["Content-Type"] && options.body) {
    retryHeaders["Content-Type"] = "application/json";
  }

  return fetch(`${BASE_URL}api/${path}`, {
    ...options,
    headers: retryHeaders,
    credentials: "include",
  });
}
